(function () {
  "use strict";
  function S(r) {
    const e = {};
    for (const t of r.zones) e[t.id] = t.defaultColor;
    return { configVersion: r.configVersion, size: r.sizes[0], zones: e };
  }
  function z(r, e) {
    return { ...r, size: e };
  }
  const L = "S41.",
    x = "S42.",
    T = new TextEncoder();
  new TextDecoder();
  const q = (() => {
      const r = document.getElementById("s4-i18n");
      if (!r) return {};
      try {
        const e = JSON.parse(r.textContent || "{}");
        return e && typeof e == "object" && !Array.isArray(e) ? e : {};
      } catch {
        return {};
      }
    })(),
    F = {
      topSkin: "cart_property_top_skin",
      bottomSkin: "cart_property_bottom_skin",
      powerband: "cart_property_powerband",
      slider: "cart_property_slider",
    },
    G = {
      white: "color_white",
      black: "color_black",
      red: "color_red",
      "royal-blue": "color_royal_blue",
      blueberry: "color_blueberry",
      "neon-yellow": "color_neon_yellow",
      "neon-green": "color_neon_green",
      orange: "color_orange",
      pink: "color_pink",
      purple: "color_purple",
      grey: "color_grey",
      navy: "color_navy",
    };
  function K(r, e = {}) {
    const t = typeof q[r] == "string" ? q[r] : r;
    return t.replace(/\{\{\s*([\w-]+)\s*\}\}/g, (n, s) =>
      Object.prototype.hasOwnProperty.call(e, s) ? String(e[s]) : n,
    );
  }
  function w(r) {
    return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  function N(r) {
    const e = [];
    for (let n = 0; n < r.length; n += 8192)
      e.push(String.fromCharCode(...r.subarray(n, n + 8192)));
    return e.join("");
  }
  function R(r) {
    return w(N(r));
  }
  function P() {
    return typeof CompressionStream < "u";
  }
  async function I(r) {
    const e = new CompressionStream("deflate-raw"),
      t = e.writable.getWriter();
    (t.write(r), t.close());
    const n = [],
      s = e.readable.getReader();
    for (;;) {
      const { done: o, value: l } = await s.read();
      if (o) break;
      n.push(l);
    }
    let i = 0;
    for (const o of n) i += o.length;
    const a = new Uint8Array(i);
    let c = 0;
    for (const o of n) (a.set(o, c), (c += o.length));
    return a;
  }
  async function C(r) {
    const e = JSON.stringify(r);
    if (P()) {
      const t = await I(T.encode(e));
      return `${x}${R(t)}`;
    }
    return `${L}${w(e)}`;
  }
  const U = new Set([119, 129, 139, 149, 159, 169, 189]);
  function A(r) {
    const e = r;
    if (e.brand !== "JYRO" || e.model !== "Safire 4")
      throw new Error(
        `Invalid config: expected JYRO Safire 4, got ${e.brand} ${e.model}`,
      );
    if (typeof e.configVersion != "string" || e.configVersion.length === 0)
      throw new Error("Invalid config: missing configVersion");
    const t = e.sizes;
    if (!Array.isArray(t) || t.length === 0)
      throw new Error("Invalid config: sizes must be a non-empty array");
    for (const i of t)
      if (!U.has(i)) throw new Error(`Invalid config: unknown size ${i}`);
    const n = e.zones;
    if (!Array.isArray(n) || n.length === 0)
      throw new Error("Invalid config: zones must be a non-empty array");
    const s = e.priceSignatures;
    if (!Array.isArray(s) || s.length === 0)
      throw new Error(
        "Invalid config: priceSignatures must be a non-empty array",
      );
    return e;
  }
  function v(r, e, t) {
    const n = r.priceSignatures.find((s) => s.size === e && s.lineType === t);
    if (!n) {
      const s = r.priceSignatures.find(
        (i) => i.size === e && i.lineType === r.defaultLines,
      );
      if (!s) throw new Error(`No variant for size ${e} / ${t}`);
      return s.variantId;
    }
    return n.variantId;
  }
  function m(r, e) {
    const t = r.priceSignatures.find((n) => n.size === e);
    if (!t) throw new Error(`No price signature for size ${e}`);
    return t.priceEur;
  }
  function V(r, e, t) {
    const n = r.zones.find((i) => i.id === e);
    if (!n) return t;
    const s = n.colors.find((i) => i.id === t);
    // Cart values remain the native runtime values; locale labels are for UI only.
    return s ? s.label : t;
  }
  function B(r, e, t, n) {
    const s = v(r, e.size, t),
      i = { _source: "Custom Design" };
    for (const a of r.zones) {
      const c = e.zones[a.id];
      c && (i[a.label] = V(r, a.id, c));
    }
    return (
      n.previewUrl && (i["_Design Preview"] = n.previewUrl),
      n.designLink && (i["_Design Link"] = n.designLink),
      { items: [{ id: s, quantity: 1, properties: i }] }
    );
  }
  function O(r, e) {
    const t = r.defaultLines || "Vectran 750",
      n = v(r, e.size, t),
      s = {
        Colors: e.colors,
        Status: e.status === "ready" ? "Ready" : "In Production",
        _source: "JYRO Stock",
      };
    return { items: [{ id: n, quantity: 1, properties: s }] };
  }
  const f = {
      normal: {
        position: [-17.287, 33.031, 39.847],
        target: [14.407, 30.922, 0],
        fov: 28,
      },
      top: {
        position: [12.407, 114.292, 0.008],
        target: [9.407, 31.922, 0],
        fov: 21,
      },
      bottom: {
        position: [6.407, -50.448, 0.008],
        target: [9.407, 31.922, 0],
        fov: 22,
      },
      back: {
        position: [86.963, 90.478, 37.556],
        target: [14.407, 34.922, 4],
        fov: 17,
      },
    },
    g = class g {
      constructor() {
        ((this.iframe = null),
          (this.state = "unknown"),
          (this.listeners = new Map()),
          (this.readyResolve = null),
          (this.registered = !1),
          (this.handleMessage = (e) => {
            var a, c;
            if (!((a = e.origin) != null && a.includes("emersya.com"))) return;
            const t = e.data;
            if (!t || typeof t != "object") return;
            const n = t.action;
            if (n === "onStateChange") {
              const o = t.state;
              (o == null ? void 0 : o.viewerState) === "loaded"
                ? ((this.state = "loaded"),
                  (this.registered = !0),
                  (c = this.readyResolve) == null || c.call(this),
                  (this.readyResolve = null))
                : (o == null ? void 0 : o.viewerState) === "loading" &&
                  (this.state = "loading");
            }
            const s = this.listeners.get(n);
            if (s) for (const o of s) o(t);
            const i = this.listeners.get("*");
            if (i) for (const o of i) o(t);
          }),
          (this.readyPromise = new Promise((e) => {
            this.readyResolve = e;
          })),
          window.addEventListener("message", this.handleMessage));
      }
      embed(e) {
        return (
          (this.iframe = document.createElement("iframe")),
          (this.iframe.src = g.APP_URL),
          (this.iframe.className = "s4-emersya-iframe"),
          (this.iframe.allow = "autoplay; fullscreen; xr-spatial-tracking"),
          (this.iframe.allowFullscreen = !0),
          this.iframe.setAttribute("loading", "lazy"),
          e.appendChild(this.iframe),
          this.iframe.addEventListener("load", () => {
            setTimeout(() => this.register(), 1500);
          }),
          this.readyPromise
        );
      }
      register() {
        this.registered || this.send({ action: "registerCallback" });
      }
      send(e) {
        var t;
        (t = this.iframe) != null &&
          t.contentWindow &&
          this.iframe.contentWindow.postMessage(e, "*");
      }
      on(e, t) {
        (this.listeners.has(e) || this.listeners.set(e, new Set()),
          this.listeners.get(e).add(t));
      }
      off(e, t) {
        var n;
        (n = this.listeners.get(e)) == null || n.delete(t);
      }
      getState() {
        return this.state;
      }
      isReady() {
        return this.state === "loaded";
      }
      getCurrentConfiguration() {
        return new Promise((e) => {
          const t = (n) => {
            this.off("onGetCurrentConfiguration", t);
            const s = n.configuration;
            if (typeof s == "string")
              try {
                e(JSON.parse(s));
              } catch {
                e({});
              }
            else e(typeof s == "object" && s !== null ? s : {});
          };
          (this.on("onGetCurrentConfiguration", t),
            this.send({ action: "getCurrentConfiguration" }));
        });
      }
      setConfiguration(e) {
        this.send({ action: "setDefaultConfiguration", configuration: e });
      }
      setCamera(e) {
        this.send({
          action: "setCamera",
          position: e.position,
          target: e.target,
          up: e.up ?? [0, 1, 0],
          transitionTime: e.transitionTime ?? 800,
          fov: e.fov ?? 28,
          unstoppable: e.unstoppable ?? !1,
        });
      }
      getScreenshot(e = 512, t = 280) {
        return new Promise((n, s) => {
          const i = setTimeout(() => {
              (this.off("onScreenshot", a), s(new Error("Screenshot timeout")));
            }, 1e4),
            a = (c) => {
              (clearTimeout(i), this.off("onScreenshot", a));
              const o = c.screenshot;
              o ? n(o) : s(new Error("No screenshot data"));
            };
          (this.on("onScreenshot", a),
            this.send({
              action: "getScreenshot",
              width: e,
              height: t,
              takebackground: !0,
            }));
        });
      }
      async getMultiViewScreenshots() {
        const e = ["normal", "top", "bottom", "back"],
          t = [];
        for (const n of e) {
          const s = f[n];
          (this.setCamera({
            position: s.position,
            target: s.target,
            fov: s.fov,
            transitionTime: 600,
            unstoppable: !0,
          }),
            await new Promise((i) => setTimeout(i, 800)));
          try {
            const i = await this.getScreenshot(512, 280);
            t.push({ dataUrl: i, view: n });
          } catch {}
        }
        return (
          this.setCamera({
            position: f.normal.position,
            target: f.normal.target,
            fov: f.normal.fov,
            transitionTime: 600,
          }),
          t
        );
      }
      destroy() {
        var e;
        (window.removeEventListener("message", this.handleMessage),
          this.listeners.clear(),
          (e = this.iframe) != null &&
            e.parentElement &&
            this.iframe.parentElement.removeChild(this.iframe),
          (this.iframe = null));
      }
    };
  g.APP_URL = "https://emersya.com/app/CXH5LTHRBR?model=safire4";
  let _ = g;
  const j = {
    jyro_configurator_started: "ViewContent",
    jyro_configuration_saved: "Lead",
    jyro_add_to_cart_clicked: "AddToCart",
    jyro_custom_added_to_cart: "AddToCart",
    jyro_stock_added_to_cart: "AddToCart",
  };
  function u(r, e = {}) {
    if (
      ((window.dataLayer ?? (window.dataLayer = [])).push({ ...e, event: r }),
      typeof window.fbq == "function")
    ) {
      const n = j[r];
      n ? window.fbq("track", n, e) : window.fbq("trackCustom", r, e);
    }
  }
  const p = class p {
    constructor(e, t) {
      ((this.selectedLines = "Vectran 750"),
        (this.root = e),
        (this.options = t),
        (this.state = S(t.config)),
        (this.bridge = new _()),
        t.config.defaultLines && (this.selectedLines = t.config.defaultLines));
    }
    async mount() {
      (this.render(),
        u("jyro_configurator_started", {
          model: "Safire 4",
          configVersion: this.options.config.configVersion,
        }));
    }
    render() {
      ((this.root.innerHTML = ""), (this.root.className = "s4-configurator"));
      const e = document.createElement("div");
      ((e.className = "s4-configurator__header"),
        (e.innerHTML = `
      <h2 class="s4-configurator__title">${h(K("configurator_title"))}</h2>
      <p class="s4-configurator__subtitle">${h(K("configurator_subtitle"))}</p>
    `),
        this.root.appendChild(e));
      const t = document.createElement("div");
      t.className = "s4-configurator__viewer";
      const n = document.createElement("div");
      ((n.className = "s4-configurator__loading"),
        (n.innerHTML = `
      <div class="s4-configurator__loading-spinner"></div>
      <p>${h(K("configurator_loading"))}</p>
    `),
        t.appendChild(n),
        this.root.appendChild(t),
        this.bridge.embed(t).then(() => {
          n.style.display = "none";
        }));
      const s = document.createElement("div");
      ((s.className = "s4-configurator__options-bar"),
        s.appendChild(this.buildSizeSelector()),
        s.appendChild(this.buildLinesSelector()),
        this.root.appendChild(s),
        this.root.appendChild(this.buildBottomBar()));
    }
    buildSizeSelector() {
      const e = document.createElement("fieldset");
      ((e.className = "s4-configurator__fieldset"),
        (e.innerHTML = `<legend class="s4-configurator__legend">${h(K("configurator_size"))}</legend>`));
      const t = document.createElement("div");
      t.className = "s4-configurator__size-pills";
      for (const n of this.options.config.sizes) {
        const s = document.createElement("button");
        ((s.className = "s4-configurator__size-pill"),
          this.state.size === n &&
            s.classList.add("s4-configurator__size-pill--active"),
          (s.textContent = String(n)),
          (s.type = "button"),
          s.addEventListener("click", () => {
            ((this.state = z(this.state, n)),
              u("jyro_size_selected", { size: n }),
              this.updatePriceDisplay(),
              this.refreshSizePills());
          }),
          t.appendChild(s));
      }
      return (e.appendChild(t), e);
    }
    refreshSizePills() {
      this.root
        .querySelectorAll(
          ".s4-configurator__size-pill:not(.s4-configurator__line-pill)",
        )
        .forEach((t) => {
          const n = Number(t.textContent);
          t.classList.toggle(
            "s4-configurator__size-pill--active",
            n === this.state.size,
          );
        });
    }
    buildLinesSelector() {
      const e = document.createElement("fieldset");
      ((e.className = "s4-configurator__fieldset"),
        (e.innerHTML = `<legend class="s4-configurator__legend">${h(K("configurator_line_type"))}</legend>`));
      const t = document.createElement("div");
      t.className = "s4-configurator__size-pills";
      const n = this.options.config.lineOptions || [
        "Vectran 750",
        "Vectran 500",
      ];
      for (const s of n) {
        const i = document.createElement("button");
        ((i.className =
          "s4-configurator__size-pill s4-configurator__line-pill"),
          this.selectedLines === s &&
            i.classList.add("s4-configurator__size-pill--active"),
          (i.dataset.lineType = s),
          (i.textContent =
            s === "Vectran 750"
              ? K("line_option_vectran_750")
              : s === "Vectran 500"
                ? K("line_option_vectran_500")
                : s),
          (i.type = "button"),
          i.addEventListener("click", () => {
            ((this.selectedLines = s),
              t.querySelectorAll(".s4-configurator__line-pill").forEach((a) => {
                a.classList.toggle(
                  "s4-configurator__size-pill--active",
                  a.dataset.lineType === s,
                );
              }));
          }),
          t.appendChild(i));
      }
      return (e.appendChild(t), e);
    }
    buildBottomBar() {
      const e = document.createElement("div");
      e.className = "s4-configurator__bottom-bar";
      const t = document.createElement("div");
      t.className = "s4-configurator__price-wrap";
      const n = document.createElement("span");
      ((n.className = "s4-configurator__price-label"),
        (n.textContent = K("custom_order")),
        t.appendChild(n));
      const s = document.createElement("span");
      ((s.className = "s4-configurator__price"),
        (s.id = "s4-price-display"),
        (s.textContent = this.formatPrice()),
        t.appendChild(s));
      const i = document.createElement("span");
      ((i.className = "s4-configurator__lead-time"),
        (i.textContent = K("configurator_lead_time")),
        t.appendChild(i),
        e.appendChild(t));
      const a = document.createElement("div");
      a.className = "s4-configurator__actions";
      const c = document.createElement("button");
      ((c.className = "s4-configurator__btn s4-configurator__btn--outline"),
        (c.textContent = K("save_design")),
        (c.type = "button"),
        c.addEventListener("click", () => this.handleSave()),
        a.appendChild(c));
      const o = document.createElement("button");
      return (
        (o.className = "s4-configurator__btn s4-configurator__btn--solid"),
        (o.textContent = K("add_to_cart")),
        (o.type = "button"),
        o.addEventListener("click", () => this.handleAddToCart()),
        a.appendChild(o),
        e.appendChild(a),
        e
      );
    }
    formatPrice() {
      const e = m(this.options.config, this.state.size);
      return new Intl.NumberFormat(this.options.locale || K("currency_locale"), {
        style: "currency",
        currency: this.options.currency || K("currency_code"),
      }).format(e);
    }
    updatePriceDisplay() {
      const e = document.getElementById("s4-price-display");
      e && (e.textContent = this.formatPrice());
    }
    async captureDesign() {
      let e = {},
        t = null;
      if (this.bridge.isReady()) {
        try {
          e = await this.bridge.getCurrentConfiguration();
        } catch {}
        try {
          t = await this.bridge.getScreenshot(512, 280);
        } catch {}
      }
      return { colorConfig: e, screenshotDataUrl: t };
    }
    async handleSave() {
      const { colorConfig: e } = await this.captureDesign(),
        t = { ...this.state, zones: e },
        n = await C(t),
        s = new URL(this.options.productUrl, window.location.origin);
      (s.searchParams.set("s4c", n),
        window.history.replaceState(null, "", s.toString()));
      let i = s.toString();
      try {
        i = await this.shortenUrl(s.toString());
      } catch {}
      (u("jyro_configuration_saved", { size: this.state.size, configCode: n }),
        this.showSharePanel(i));
    }
    showSharePanel(e) {
      const t = this.root.querySelector(".s4-configurator__share-panel");
      t && t.remove();
      const n = document.createElement("div");
      n.className = "s4-configurator__share-panel";
      const s = document.createElement("p");
      ((s.className = "s4-configurator__share-heading"),
        (s.textContent = K("design_saved")),
        n.appendChild(s));
      const i = document.createElement("div");
      i.className = "s4-configurator__share-url-wrap";
      const a = document.createElement("input");
      ((a.type = "text"),
        (a.readOnly = !0),
        (a.value = e),
        (a.className = "s4-configurator__share-url"),
        i.appendChild(a),
        n.appendChild(i));
      const c = document.createElement("div");
      c.className = "s4-configurator__share-btns";
      const o = document.createElement("button");
      ((o.type = "button"),
        (o.className =
          "s4-configurator__btn s4-configurator__btn--outline s4-configurator__share-copy"),
        (o.textContent = K("copy_link")),
        o.addEventListener("click", async () => {
          try {
            (await navigator.clipboard.writeText(e),
              (o.textContent = K("copied")),
              o.classList.add("s4-configurator__btn--success"),
              setTimeout(() => {
                ((o.textContent = K("copy_link")),
                  o.classList.remove("s4-configurator__btn--success"));
              }, 2e3));
          } catch {
            a.select();
          }
        }),
        c.appendChild(o));
      const l = document.createElement("a");
      ((l.className = "s4-configurator__btn s4-configurator__btn--whatsapp"),
        (l.href = `https://wa.me/?text=${encodeURIComponent(K("whatsapp_message", { url: e }))}`),
        (l.target = "_blank"),
        (l.rel = "noopener"),
        (l.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>'),
        l.append(document.createTextNode(` ${K("whatsapp")}`)),
        c.appendChild(l),
        n.appendChild(c));
      const d = document.createElement("button");
      ((d.type = "button"),
        (d.className = "s4-configurator__share-close"),
        (d.textContent = K("close")),
        d.addEventListener("click", () => n.remove()),
        n.appendChild(d));
      const k = this.root.querySelector(".s4-configurator__bottom-bar");
      k ? k.after(n) : this.root.appendChild(n);
    }
    async handleAddToCart() {
      u("jyro_add_to_cart_clicked", { size: this.state.size });
      const { colorConfig: e, screenshotDataUrl: t } =
        await this.captureDesign();
      let n, s;
      if (t)
        try {
          const a = await this.dataUrlToBlob(t);
          n = await this.uploadPreview(a);
        } catch {}
      try {
        const a = { ...this.state, zones: e },
          c = await C(a);
        s = await this.shortenUrl(`${this.options.productUrl}?s4c=${c}`);
      } catch {}
      const i = B(this.options.config, this.state, this.selectedLines, {
        previewUrl: n,
        designLink: s,
      });
      if (
        i.items.length > 0 &&
        ((i.items[0].properties["Line Type"] = this.selectedLines),
        Object.keys(e).length > 0)
      ) {
        const a = [],
          c = [];
        let o = "";
        for (const [l, d] of Object.entries(e)) {
          const k = d;
          l.startsWith("canopy_l") ||
          l.startsWith("canopy_n") ||
          l.match(/^canopy_\d/)
            ? a.includes(k) || a.push(k)
            : l.startsWith("powerband") || l.includes("powerband")
              ? c.includes(k) || c.push(k)
              : (l === "canopy_sl" || l.includes("slider")) && (o = k);
        }
        (a.length > 0 &&
          (i.items[0].properties["Top Skin"] = a.join(", ")),
          c.length > 0 &&
            (i.items[0].properties.Powerband = c.join(", ")),
          o && (i.items[0].properties.Slider = o));
      }
      (u("jyro_custom_added_to_cart", {
        size: this.state.size,
        lineType: this.selectedLines,
        value: m(this.options.config, this.state.size),
        currency: this.options.currency || K("currency_code"),
      }),
        this.options.onAddToCart(i));
    }
    dataUrlToBlob(e) {
      return fetch(e).then((t) => t.blob());
    }
    async uploadPreview(e) {
      const t = await fetch(p.SHARED_WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filename: "preview.png",
          folder: "jyro-safire4/previews",
        }),
      });
      if (!t.ok) throw new Error("Failed to get upload signature");
      const { url: n, fields: s } = await t.json(),
        i = new FormData();
      for (const [o, l] of Object.entries(s)) i.append(o, l);
      i.append("file", e, "preview.png");
      const a = await fetch(n, { method: "POST", body: i });
      if (!a.ok) throw new Error("Upload failed");
      return (await a.json()).secure_url;
    }
    async shortenUrl(e) {
      const t = await fetch(`${p.SHARED_WORKER_URL}/shorten`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url: e, prefix: "jyro" }),
      });
      if (!t.ok) throw new Error("URL shortening failed");
      return (await t.json()).shortURL;
    }
  };
  p.SHARED_WORKER_URL = "https://tfx-photo-upload.young-sky-a2c1.workers.dev";
  let b = p;
  function $(r) {
    return r
      .replace(/&#8211;/g, "–")
      .replace(/&#8212;/g, "—")
      .replace(/&#38;/g, "&")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&nbsp;/g, " ");
  }
  function h(r) {
    return $(r)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }
  class D {
    constructor(e, t) {
      ((this.canopies = []),
        (this.activeFilter = null),
        (this.expanded = !1),
        (this.root = e),
        (this.options = t));
    }
    async mount() {
      this.root.innerHTML = `<p class="s4-stock__loading">${h(K("stock_loading"))}</p>`;
      try {
        const e = await fetch(`${this.options.apiBaseUrl}/api/stock/safire-4`);
        if (!e.ok) throw new Error(`Stock API ${e.status}`);
        const t = await e.json();
        ((this.canopies = t.canopies),
          u("jyro_stock_grid_viewed", { count: this.canopies.length }));
      } catch {
        this.root.innerHTML = `<p class="s4-stock__error">${h(K("stock_load_error"))}</p>`;
        return;
      }
      this.render();
    }
    render() {
      const e = this.activeFilter
          ? this.canopies.filter((i) => i.size === this.activeFilter)
          : this.canopies,
        t = this.expanded ? e : e.slice(0, 4),
        n = e.length > 4 && !this.expanded;
      ((this.root.innerHTML = ""),
        this.root.appendChild(this.buildHeader()),
        this.root.appendChild(this.buildFilterPills()),
        this.root.appendChild(this.buildLegend()));
      const s = document.createElement("div");
      s.className = "s4-stock__grid";
      for (const i of t) s.appendChild(this.buildCard(i));
      if ((this.root.appendChild(s), n)) {
        const i = document.createElement("button");
        ((i.className = "s4-stock__show-all"),
          (i.textContent = K("show_all_stock", { count: e.length })),
          i.addEventListener("click", () => {
            ((this.expanded = !0), this.render());
          }),
          this.root.appendChild(i));
      }
    }
    buildHeader() {
      const e = document.createElement("div");
      return (
        (e.className = "s4-stock__header"),
        (e.innerHTML = `
      <h2 class="s4-stock__title">${h(K("stock_heading"))}</h2>
      <span class="s4-stock__updated">${h(K("updated_daily"))}</span>
    `),
        e
      );
    }
    buildFilterPills() {
      const e = document.createElement("nav");
      ((e.className = "s4-stock__filters"),
        e.setAttribute("aria-label", K("stock_filter_aria_label")));
      const t = [null, ...this.options.config.sizes];
      for (const n of t) {
        const s = document.createElement("button");
        ((s.className = "s4-stock__filter-pill"),
          this.activeFilter === n &&
            s.classList.add("s4-stock__filter-pill--active"),
          (s.textContent =
            n === null ? K("all") : K("stock_filter_size", { size: n })),
          s.addEventListener("click", () => {
            ((this.activeFilter = n),
              (this.expanded = !1),
              u("jyro_stock_filter_used", { size: n ?? "all" }),
              this.render());
          }),
          e.appendChild(s));
      }
      return e;
    }
    buildLegend() {
      const e = document.createElement("div");
      return (
        (e.className = "s4-stock__legend"),
        (e.innerHTML = `
      <span class="s4-stock__legend-item"><span class="s4-stock__badge s4-stock__badge--ready"></span> ${h(K("ready"))}</span>
      <span class="s4-stock__legend-item"><span class="s4-stock__badge s4-stock__badge--production"></span> ${h(K("in_production"))}</span>
    `),
        e
      );
    }
    buildCard(e) {
      const t = document.createElement("article");
      t.className = "s4-stock__card";
      const n = K("stock_card_badge", {
          status: e.status === "ready" ? K("ready") : K("in_production"),
        }),
        s =
          e.status === "ready"
            ? "s4-stock__badge--ready"
            : "s4-stock__badge--production",
        i = e.status === "ready" ? K("add_to_cart") : K("pre_order");
      let a = "";
      try {
        const o = m(this.options.config, e.size),
          l = new Intl.NumberFormat(
            this.options.locale || K("currency_locale"),
            {
              style: "currency",
              currency: this.options.currency || K("currency_code"),
            },
          ).format(o);
        a = `<p class="s4-stock__card-price">${h(K("stock_card_price", { price: l }))}</p>`;
      } catch {}
      t.innerHTML = `
      <div class="s4-stock__card-img-wrap">
        <img class="s4-stock__card-img" src="${h(e.imageUrl)}" alt="${h(K("stock_card_image_alt", { brand: this.options.config.brand, model: e.model, size: e.size }))}" loading="lazy" />
        <span class="s4-stock__badge ${s}">${h(n)}</span>
      </div>
      <div class="s4-stock__card-body">
        <h3 class="s4-stock__card-title">${h(K("stock_card_title", { model: e.model, size: e.size }))}</h3>
        <p class="s4-stock__card-colors">${h(K("stock_card_colors", { colors: e.colors }))}</p>
        ${a}
      </div>
    `;
      const c = document.createElement("button");
      return (
        (c.className = "s4-stock__card-cta"),
        (c.textContent = i),
        c.addEventListener("click", () => {
          const o = O(this.options.config, e);
          (u("jyro_stock_added_to_cart", {
            size: e.size,
            status: e.status,
            value: e.price / 100,
            currency: e.currency,
          }),
            this.options.onAddToCart(o));
        }),
        t.querySelector(".s4-stock__card-body").appendChild(c),
        t
      );
    }
  }
  const H = {
    brand: "JYRO",
    model: "Safire 4",
    productHandle: "jyro-safire-4",
    configVersion: "safire4-2026-05-24",
    sizes: [119, 129, 139, 149, 159, 169, 189],
    zones: [
      {
        id: "topSkin",
        label: "Top Skin",
        colors: [
          { id: "white", label: "White", hex: "#ffffff" },
          { id: "black", label: "Black", hex: "#1a1a18" },
          { id: "red", label: "Red", hex: "#e01020" },
          { id: "royal-blue", label: "Royal Blue", hex: "#1a5acd" },
          { id: "blueberry", label: "Blueberry", hex: "#3ba4d9" },
          { id: "neon-yellow", label: "Neon Yellow", hex: "#d4f800" },
          { id: "neon-green", label: "Neon Green", hex: "#39e832" },
          { id: "orange", label: "Orange", hex: "#ff6600" },
          { id: "pink", label: "Pink", hex: "#ff4daa" },
          { id: "purple", label: "Purple", hex: "#7b2fbe" },
          { id: "grey", label: "Grey", hex: "#8c8c8c" },
          { id: "navy", label: "Navy", hex: "#1a2255" },
        ],
        defaultColor: "royal-blue",
        layerImage: "",
      },
      {
        id: "bottomSkin",
        label: "Bottom Skin",
        colors: [
          { id: "white", label: "White", hex: "#ffffff" },
          { id: "black", label: "Black", hex: "#1a1a18" },
          { id: "red", label: "Red", hex: "#e01020" },
          { id: "royal-blue", label: "Royal Blue", hex: "#1a5acd" },
          { id: "blueberry", label: "Blueberry", hex: "#3ba4d9" },
          { id: "neon-yellow", label: "Neon Yellow", hex: "#d4f800" },
          { id: "neon-green", label: "Neon Green", hex: "#39e832" },
          { id: "orange", label: "Orange", hex: "#ff6600" },
          { id: "pink", label: "Pink", hex: "#ff4daa" },
          { id: "purple", label: "Purple", hex: "#7b2fbe" },
          { id: "grey", label: "Grey", hex: "#8c8c8c" },
          { id: "navy", label: "Navy", hex: "#1a2255" },
        ],
        defaultColor: "white",
        layerImage: "",
      },
      {
        id: "powerband",
        label: "Powerband",
        colors: [
          { id: "black", label: "Black", hex: "#1a1a18" },
          { id: "white", label: "White", hex: "#ffffff" },
          { id: "red", label: "Red", hex: "#e01020" },
          { id: "royal-blue", label: "Royal Blue", hex: "#1a5acd" },
          { id: "neon-yellow", label: "Neon Yellow", hex: "#d4f800" },
          { id: "neon-green", label: "Neon Green", hex: "#39e832" },
          { id: "orange", label: "Orange", hex: "#ff6600" },
        ],
        defaultColor: "black",
        layerImage: "",
      },
      {
        id: "slider",
        label: "Slider",
        colors: [
          { id: "white", label: "White", hex: "#ffffff" },
          { id: "black", label: "Black", hex: "#1a1a18" },
          { id: "red", label: "Red", hex: "#e01020" },
          { id: "royal-blue", label: "Royal Blue", hex: "#1a5acd" },
          { id: "blueberry", label: "Blueberry", hex: "#3ba4d9" },
          { id: "neon-yellow", label: "Neon Yellow", hex: "#d4f800" },
          { id: "neon-green", label: "Neon Green", hex: "#39e832" },
        ],
        defaultColor: "royal-blue",
        layerImage: "",
      },
    ],
    lineOptions: ["Vectran 750", "Vectran 500"],
    defaultLines: "Vectran 750",
    priceSignatures: [
      {
        size: 119,
        lineType: "Vectran 750",
        variantId: 53416470315351,
        priceEur: 3360,
      },
      {
        size: 119,
        lineType: "Vectran 500",
        variantId: 53416470348119,
        priceEur: 3360,
      },
      {
        size: 129,
        lineType: "Vectran 750",
        variantId: 53416470380887,
        priceEur: 3360,
      },
      {
        size: 129,
        lineType: "Vectran 500",
        variantId: 53416470413655,
        priceEur: 3360,
      },
      {
        size: 139,
        lineType: "Vectran 750",
        variantId: 53416470446423,
        priceEur: 3360,
      },
      {
        size: 139,
        lineType: "Vectran 500",
        variantId: 53416470479191,
        priceEur: 3360,
      },
      {
        size: 149,
        lineType: "Vectran 750",
        variantId: 53416470511959,
        priceEur: 3360,
      },
      {
        size: 149,
        lineType: "Vectran 500",
        variantId: 53416470544727,
        priceEur: 3360,
      },
      {
        size: 159,
        lineType: "Vectran 750",
        variantId: 53416470577495,
        priceEur: 3360,
      },
      {
        size: 159,
        lineType: "Vectran 500",
        variantId: 53416470610263,
        priceEur: 3360,
      },
      {
        size: 169,
        lineType: "Vectran 750",
        variantId: 53416470643031,
        priceEur: 3360,
      },
      {
        size: 169,
        lineType: "Vectran 500",
        variantId: 53416470675799,
        priceEur: 3360,
      },
      {
        size: 189,
        lineType: "Vectran 750",
        variantId: 53416470774103,
        priceEur: 3360,
      },
      {
        size: 189,
        lineType: "Vectran 500",
        variantId: 53416470806871,
        priceEur: 3360,
      },
    ],
  };
  function E(r) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(r),
    })
      .then((e) => {
        if (!e.ok) throw new Error(`Cart error ${e.status}`);
        window.location.href = "/cart";
      })
      .catch((e) => {
        (console.error("Add to cart failed:", e), alert(K("cart_add_error")));
      });
  }
  function y() {
    const r = A(H);
    (document.querySelectorAll("[data-s4-configurator-root]").forEach((e) => {
      const t = {
        config: r,
        productUrl: e.dataset.productUrl ?? window.location.href,
        locale: e.dataset.locale ?? "en",
        currency: e.dataset.currency ?? "EUR",
        assetBase: e.dataset.assetBase ?? "",
        workerBaseUrl: e.dataset.workerBaseUrl ?? "",
        onAddToCart: E,
      };
      new b(e, t).mount();
    }),
      document.querySelectorAll("[data-s4-stock-root]").forEach((e) => {
        const t = e.dataset.workerBaseUrl ?? "";
        new D(e, {
          config: r,
          apiBaseUrl: t,
          currency: e.dataset.currency ?? "EUR",
          onAddToCart: E,
        }).mount();
      }));
  }
  ((window.JyroSafire4 = { mountAll: y }),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", y)
      : y());
})();
